import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'underscore';
import * as $ from 'jquery';

import StringField from '../../../_common/platform/tsx/StringField';

import * as appTheme from '../../../_common/platform/ts/appTheme';
//import { validators } from '../../../_common/platform/ts/validators';
import { CKEditPopupComponent } from '../../../_common/platform/tsx/CKEditPopupField';
import { IGlob } from '../../../_common/application/ts/Glob';
import { CKEDITOR_CONFIG_STATIC } from '../../../_common/platform/ts/Utilities';

interface IProps {
    index: number;
    value: { name: string; template: string };
    onChange: (...args) => any;
    glob: IGlob;
}

export class TemplateListRow extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    private normalize(value) {}

    private handleValueChange(value) {
        this.normalize(value);

        delete value.inherited;

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.index);
        }
    }

    private processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };

    private processNameClick = (e) => {
        let obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    };

    private processTemplateChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.template = val;
        this.handleValueChange(obj);
    };

    private getNameTitle(value) {
        return value.name || '';
    }

    private getName(value) {
        let displayVal = value.name || '';

        if (value.name == null) {
            let displayValEmpty = (
                <em className="empty" onClick={this.processNameClick}>
                    add
                </em>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="glyphicon glyphicon-cog" onClick={this.processNameClick}></span>
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        let readOnly = value.disabled === true;

        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    private handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.index);
        }
    };

    private getRemoveButton(value) {
        if (value.name == null) {
            return;
        }

        if (value.disabled === true) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    private getTemplate(value) {
        if (value.template == null) {
            return;
        }

        return (
            <CKEditPopupComponent
                value={value.template}
                hidePreview={true}
                editorConfig={$.extend(true, {}, CKEDITOR_CONFIG_STATIC, {
                    width: 600,
                    height: 400
                })}
                glob={this.props.glob}
                onChange={this.processTemplateChange}
            />
        );
    }

    render() {
        let value = this.props.value || {};

        return (
            <tr>
                <td className="align-top w-auto">{this.getRemoveButton(value)}</td>
                <td className="align-top w-auto" title={this.getNameTitle(value)}>
                    {this.getName(value)}
                </td>
                <td className="align-top w-75">{this.getTemplate(value)}</td>
            </tr>
        );
    }
}

export class TemplateList extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    private addRow = (obj) => {
        let arr = this.props.value.slice(0);

        obj.template = '';

        obj.disabled = false;

        arr.push(obj);
        this.handleValueChange(arr);
    };

    private changeRow = (obj, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    private removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    private handleValueChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    render() {
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let rows = _.map(this.props.value, (val, index) => {
            let _actualVal: any = appTheme.setProperInheritedFlag(val, ownValues, parentValues, 'TemplateListField');

            return (
                <TemplateListRow
                    key={'templateRow' + index}
                    index={index}
                    value={_actualVal}
                    onChange={this.changeRow}
                    onRemove={this.removeRow}
                    glob={this.props.glob}
                />
            );
        });

        let showTableHeaders = rows.length > 0;

        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px

        let style2 = {
            paddingBottom: 15
        };

        return (
            <div className={'colormappingfornumeric-field-inTheme'}>
                <div className={'div-container'} style={style2}>
                    <div className="colormappingfornumeric-field-inTheme-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        {showTableHeaders === true ? (
                            <thead>
                                <tr>
                                    <th className="w-auto"></th>
                                    <th className="w-auto">Name</th>
                                    <th className="w-75">Template</th>
                                </tr>
                            </thead>
                        ) : null}
                        <tbody>
                            {rows}
                            <TemplateListRow onChange={this.addRow} glob={this.props.glob} />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
